<template>
  <div class="title">
    <h1 v-band-title class="title-area" tabindex="0">
      <span class="label">{{ sectionInfo.title }}</span>
    </h1>
  </div>
</template>
<script>
  import { bandTitle } from '@/common/resources/directives'
  export default {
    name: 'BandTitle',
    directives: {
      bandTitle,
    },
    props: {
      sectionInfo: {
        type: Object,
        default: null,
      },
    },
  }
</script>
